import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';

onPageLoad(() => {
  $('.dropdown-menu__link--delete-retainer').on('click', function (e) {
    const { deleteUrl } = $(e.target).data();
    $('#modal--delete-confirmation--retainer').modal();
    $('#modal--delete-confirmation--retainer .d-button--confirm-delete').attr('href', deleteUrl);
  });
});
